import { useMemo, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { useInfiniteScrollForQuery } from "../../School/hooks";
import {
  GetArbookContentForAdminDocument,
  GetArbookContentForAdminQuery,
} from "../../../generated/graphql";
import { useDebounce } from "../../shared/Utils/OtherOperations/useDebounce";
import { LoadingProgress } from "../../shared/LoadingProgress";
import { ModalInput } from "../../shared/Style/Style";

const LIMIT = 20;

export interface ArbookContentOption {
  id: string;
  name?: string | null;
}

interface SelectArbookContentProps {
  value: ArbookContentOption | null;
  onChange: (value: ArbookContentOption | null) => void;
  disabled?: boolean;
}

export const SelectArbookContent = ({
  value,
  onChange,
  disabled,
}: SelectArbookContentProps) => {
  const [searchKey, setSearchKey] = useState("");
  const debouncedValue = useDebounce(searchKey, 500);

  const variables = useMemo(
    () => ({ searchKey: debouncedValue }),
    [debouncedValue],
  );

  const {
    items: content,
    loading,
    handleScroll,
  } = useInfiniteScrollForQuery<GetArbookContentForAdminQuery>({
    query: GetArbookContentForAdminDocument,
    variables,
    key: "params",
    limitKey: "limit",
    limit: LIMIT,
    getItems: (data) => data.getArbookContentForAdmin?.content || [],
  });

  return (
    <Autocomplete
      options={content}
      disabled={disabled}
      style={{ width: "100%" }}
      value={value}
      getOptionSelected={(option, val) => option.id === val.id}
      getOptionLabel={(option) => option.name || option.id}
      onChange={(_, selected) => {
        onChange(selected);
        setSearchKey("");
      }}
      ListboxProps={{ onScroll: handleScroll }}
      inputValue={searchKey}
      onInputChange={(_, val) => setSearchKey(val)}
      noOptionsText="Контент не знайдено"
      renderInput={(params) => (
        <>
          <ModalInput
            {...params}
            label="Цільовий контент ArBook+ *"
            margin="normal"
            onChange={(e) => setSearchKey(e.target.value)}
          />
          {loading && <LoadingProgress />}
        </>
      )}
    />
  );
};
